let resizeListenersList = {
};
let width, height;

class SizeListener {
	
	static resizeListener () {
		SizeListener.setWidthHeight();
		for (let [k, v] of Object.entries(resizeListenersList)) {
			v({ width, height });
		}
	}
	
	static setWidthHeight () {
		width  = window.innerWidth;
		height = window.innerHeight;
	}
	
	static init () {
		window.onresize = SizeListener.resizeListener;
		SizeListener.setWidthHeight();
	}
	
	static set (k, v) {
		resizeListenersList[k] = v;
	}
	
	static isPhone () {
		return width <= 760;
	}
	
}

export default SizeListener;